/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  DingXiangCeLveChaXunTiaoJian,
  DingXiangCeLveChuangJianGengXin,
  ResponseApiDingXiangCeLveXiangQing,
  ResponseApiPageDingXiangCeLveLieBiaoXiang,
  ResponseApiTargeting,
  ResponseApiVoid,
} from "./data-contracts";
import { HttpClient, RequestParams, ContentType } from '@gatherstar/utils';

export class DingXiangGuanLi<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags DingXiangGuanLi
   * @name ListTargetingsUsingPost
   * @summary 获取定向策略列表
   * @request POST:/dsp-admin/api/targeting
   * @secure
   */
  listTargetingsUsingPost = (
    query: DingXiangCeLveChaXunTiaoJian,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiPageDingXiangCeLveLieBiaoXiang, void>({
      path: `/dsp-admin/api/targeting`,
      method: "POST",
      body: query,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags DingXiangGuanLi
   * @name CreateTargetingUsingPost
   * @summary 创建定向策略
   * @request POST:/dsp-admin/api/targeting/create
   * @secure
   */
  createTargetingUsingPost = (
    dto: DingXiangCeLveChuangJianGengXin,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiTargeting, void>({
      path: `/dsp-admin/api/targeting/create`,
      method: "POST",
      body: dto,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags DingXiangGuanLi
   * @name GetTargetingUsingPost
   * @summary 获取定向策略详情
   * @request POST:/dsp-admin/api/targeting/{id}
   * @secure
   */
  getTargetingUsingPost = (id: number, params: RequestParams = {}) =>
    this.request<ResponseApiDingXiangCeLveXiangQing, void>({
      path: `/dsp-admin/api/targeting/${id}`,
      method: "POST",
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags DingXiangGuanLi
   * @name UpdateTargetingUsingPut
   * @summary 更新定向策略
   * @request PUT:/dsp-admin/api/targeting/{id}
   * @secure
   */
  updateTargetingUsingPut = (
    id: number,
    dto: DingXiangCeLveChuangJianGengXin,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiTargeting, void>({
      path: `/dsp-admin/api/targeting/${id}`,
      method: "PUT",
      body: dto,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags DingXiangGuanLi
   * @name DisableTargetingUsingDelete
   * @summary 删除定向策略
   * @request DELETE:/dsp-admin/api/targeting/{id}
   * @secure
   */
  disableTargetingUsingDelete = (id: number, params: RequestParams = {}) =>
    this.request<ResponseApiVoid, void>({
      path: `/dsp-admin/api/targeting/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
}


// 导出默认实例，可直接使用
export const api = new DingXiangGuanLi();
